module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "row",
    staticStyle: {
      "line-height": "46px",
      "padding-left": "15px"
    }
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.toggleMenu($event)
      }
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-menu-hamburger"
  }), _vm._v(" "), (_vm.menu) ? [_vm._v("Ukryj menu")] : _vm._e(), _vm._v(" "), (!_vm.menu) ? [_vm._v("Pokaż menu")] : _vm._e()], 2), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'Dashboard'
      }
    }
  }, [_c('img', {
    attrs: {
      "id": "logo",
      "src": require("./../assets/logo.png"),
      "alt": "",
      "height": "40"
    }
  })]), _vm._v("\n  - panel administracyjny\n  "), _c('button', {
    staticClass: "btn btn-primary btn-lg pull-right",
    attrs: {
      "title": "Wyloguj"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.logout($event)
      }
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-off"
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-25b25b3a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TopHeader.vue
// module id = 430
// module chunks = 1